import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const UpsertBlockedAddress = (params: any) =>
    request({
        url: ApiURL.Command.UpsertBlockedAddress,
        method: RequestType.POST,
        data: params,
    });

const DeleteBlockedAddress = (params: any) =>
    request({
        url: ApiURL.Command.DeleteBlockedAddress,
        method: RequestType.POST,
        data: params,
    });

const CargoAddressBlockingCommand = {
    UpsertBlockedAddress,
    DeleteBlockedAddress,
};

export default CargoAddressBlockingCommand;

